const e = "forma-filling__explorer-grid-item__root", i = "forma-filling__explorer-grid-item__hover", o = "forma-filling__explorer-grid-item__menuOpen", n = "forma-filling__explorer-grid-item__updated", r = "forma-filling__explorer-grid-item__selected", t = "forma-filling__explorer-grid-item__container", _ = "forma-filling__explorer-grid-item__iconContainer", l = "forma-filling__explorer-grid-item__icon", m = "forma-filling__explorer-grid-item__fave", a = "forma-filling__explorer-grid-item__checked", c = "forma-filling__explorer-grid-item__nameContainer", f = "forma-filling__explorer-grid-item__name", g = "forma-filling__explorer-grid-item__withOptions", s = "forma-filling__explorer-grid-item__optionsButton", p = {
  root: e,
  hover: i,
  menuOpen: o,
  updated: n,
  selected: r,
  container: t,
  iconContainer: _,
  icon: l,
  fave: m,
  checked: a,
  nameContainer: c,
  name: f,
  withOptions: g,
  optionsButton: s
};
export {
  p as s
};
